export default __webpack_public_path__ + "static/media/mark1.db629908.svg";